import React from 'react';
import './App.css';
import 'react-tabs/style/react-tabs.css';

import { observer } from 'mobx-react';

import { appStore } from '../store';
import { CLanguage, LuaLanguage, CSLanguage, JSLanguage } from '../syntaxHighlighting';
import { NativesList } from './NativesList';
import { NativeDetail } from './NativeDetails';
import { navigateTo } from '../navutils';


const apisets = ['all', 'server', 'client'];
const languages = {
  c: CLanguage,
  lua: LuaLanguage,
  cs: CSLanguage,
  js: JSLanguage,
};

const TopBar = observer(({ searchCb, addRefCb, setApiSetCb, setLanguageCb }) => {
  const apiSets = apisets
    .map((apiSet) => (
      <li
        key={apiSet}
        className={appStore.viewNativeList.apiset === apiSet ? 'active' : ''}
        onClick={(event) => { setApiSetCb(event.target.dataset.name); event.preventDefault() }}
        data-name={apiSet}
      >
        {apiSet}
      </li>
    ));

  const langs = Object.entries(languages)
    .map(([key, lang]) => (
      <li
        key={key}
        className={appStore.viewNativeList.language === key ? 'active' : ''}
        onClick={(event) => { setLanguageCb(event.target.dataset.name); event.preventDefault() }}
        data-name={key}
      >
        {lang.name}
      </li>)
    );

  return (
    <>
      <header>
        <div className="branding">
          <span>RedM Native Reference</span>
        </div>
        <input
          type="search"
          placeholder="Search..."
          name="search"
          onChange={(event) => searchCb(event.target.value)}
          ref={(el) => addRefCb('search', el)}
        />
      </header>
      <nav>
        <div className="toggles">
          <div className="title">API Set:</div>
          <ul>
            {apiSets}
          </ul>
        </div>

        <div className="toggles">
          <div className="title">Language:</div>
          <ul>
            {langs}
          </ul>
        </div>
      </nav>
    </>
  );
});

const LoadingIndicator = ({ loading }) => {
  if (loading) {
    return (
      <div className="loading">
        <div className="lds-ripple"><div></div><div></div></div>
      </div>
    );
  }

  return null;
};

export const App = observer(({ addRef }) => {
  const language = languages[appStore.viewNativeList.language];

  const stillLoading = appStore.viewNativeList.rawNatives.length === 0;

  const setApiSetCb = React.useCallback((apiset) => appStore.viewNativeList.apiset = apiset, []);
  const searchCb = React.useCallback((str) => appStore.viewNativeList.filter = str, []);
  const setLanguageCb = React.useCallback((language) => {
    appStore.viewNativeList.language = language;
    window.localStorage.setItem('nativeRefLanguage', language);
  }, []);

  return (
    <>
      <TopBar
        searchCb={searchCb}
        addRefCb={addRef}
        setApiSetCb={setApiSetCb}
        setLanguageCb={setLanguageCb}
      />
      <div className="app">
        <LoadingIndicator loading={stillLoading} />
        {!stillLoading && (
          <>
            <NativeDetail
              language={language}
            />
            <NativesList
              addRefCb={addRef}
              language={language}
            />
          </>
        )}
      </div>
    </>
  );
});
